export const isMobile =
  typeof navigator !== "undefined" &&
  /Mobi|Android|iPhone|iPad|Tablet/i.test(navigator.userAgent);
